module.exports = __webpack_public_path__ + "img/64.fc639e5f.png";